<template>
  <ReHeight @click.stop.self.prevent>
    <div :ref="`toolreheight${component_id}`" style="width: 100%; height: 100%">
      <ToolLabel v-if="mode == reheight_mode" class="px-2 mx-2" style="">
        W: {{ width }}, H:{{ height }}
      </ToolLabel>
    </div>
  </ReHeight>
</template>

<script>
import { mapGetters } from "vuex";

import { ReHeight, ToolLabel } from "./Reheight.styled";
export default {
  components: {
    ReHeight,
    ToolLabel,
  },
  data() {
    return {
      reheight_mode: "reheight_component",
      height: 0,
      width: 0,
      cellRow: [],
    };
  },
  computed: {
    ...mapGetters({
      components: "designIframe/metadata/components",
      gridActive: "designIframe/frame/gridActive",
      gridHover: "designIframe/frame/gridHover",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
    }),
    element() {
      return this.components[this.component_id];
    },
  },
  props: ["component_id"],
  mounted() {
    this.dragElement();
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    dragElement() {
      this.$refs[`toolreheight${this.component_id}`].onmousedown =
        this.dragMouseDown;
    },
    dragMouseDown(e) {
      e = e || window.event;
      this.$store.dispatch("design/setMode", {
        mode: this.reheight_mode,
      });
      e.preventDefault();
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      document.onmousemove = this.elementDrag;
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      const position = document.getElementById(`comp-${this.component_id}`);
      this.height = position.offsetHeight;
      this.width = position.offsetWidth;
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;

      this.components[this.component_id].style.height =
        position.offsetHeight +
        this.$refs[`toolreheight${this.component_id}`].offsetTop -
        this.pos2;
    },

    closeDragElement() {
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      this.$store.dispatch("design/setMode", {});
      document.onmouseup = null;
      document.onmousemove = null;
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        if(this.mode == this.reheight_mode) this.closeDragElement();
      }
    },
  },
  watch: {
    height() {
      setTimeout(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
      }, 1);
    }
  }
};
</script>

<style>
</style>